export default angular.module("mars.vet.dnareports.controllers.inheritance",[]).controller('InheritanceController', function($rootScope, $scope, $routeParams, $window, EntryService, EntryIDService, NavigationService) {
  EntryService.getEntry(EntryIDService.getEntryID('Inheritance')).then(function(response) {
      var fields = response.fields;
      $rootScope.pageTitle = fields.title;
      $scope.heading = fields.heading;
      var inheritanceText = fields.text.split("\n");
      $scope.paragraph_1 = inheritanceText.length > 0 ? inheritanceText[0] : '';
      $scope.paragraph_2 = inheritanceText.length > 1 ? inheritanceText[1] : '';
      $scope.paragraph_3 = inheritanceText.length > 2 ? inheritanceText[2] : '';
      $scope.paragraph_4 = inheritanceText.length > 3 ? inheritanceText[3] : '';

      $scope.link = fields.link;
      $scope.inheritanceEntryID = EntryIDService.getEntryID('Inheritance');
      $window.ga('send', 'pageview', {
          'page': $rootScope.pageTitle
      });

      NavigationService.setNavigationUrls();
  });

}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/inheritance.controller.js